import CarrierFields from "features/carriers/CarrierFields";

const CreateNewCarrier = ({ reservationDetails, onChangeValue, onChangePocField, isNew, displayError }) => {

    return (
        <CarrierFields
            carrier={reservationDetails?.carrierInfo}
            onChange={onChangeValue}
            onChangePocField={onChangePocField}
            displayError={displayError}
            isNew={isNew}
        />
    );
}

export default CreateNewCarrier;